import { useEffect, useRef, useState, Children, isValidElement, cloneElement } from 'react';

const useInView = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '-80px', threshold: 0.01 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, inView];
};

export const ScrollReveal = ({ children, delay = 0, y = 24, className = '' }) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0px)' : `translateY(${y}px)`,
        transition: `opacity 0.7s cubic-bezier(0.33,1,0.68,1) ${delay}s, transform 0.7s cubic-bezier(0.33,1,0.68,1) ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

export const StaggerReveal = ({ children, className = '', stagger = 0.08 }) => (
  <div className={className}>
    {Children.map(children, (child, i) =>
      isValidElement(child) ? cloneElement(child, { _staggerDelay: i * stagger }) : child
    )}
  </div>
);

export const StaggerItem = ({ children, className = '', y = 20, _staggerDelay = 0 }) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0px)' : `translateY(${y}px)`,
        transition: `opacity 0.6s cubic-bezier(0.33,1,0.68,1) ${_staggerDelay}s, transform 0.6s cubic-bezier(0.33,1,0.68,1) ${_staggerDelay}s`,
      }}
    >
      {children}
    </div>
  );
};
